import { render, staticRenderFns } from "./MRAboutTheData.vue?vue&type=template&id=21079f60"
import script from "./MRAboutTheData.vue?vue&type=script&lang=js"
export * from "./MRAboutTheData.vue?vue&type=script&lang=js"
import style0 from "./MRAboutTheData.vue?vue&type=style&index=0&id=21079f60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports